import {createContext, useContext, useState} from 'react'

const SearchContext = createContext(null)

export function SearchProvider({ children }) {
  const [searchText, setSearchText] = useState('')
  const [domain, setDomain] = useState('')
  const contextValue = { searchText, setSearchText, domain, setDomain }

  return (
    <SearchContext value={contextValue}>
      {children}
    </SearchContext>
  )
}

export function useSearch() {
  return useContext(SearchContext)
}
